export default __webpack_public_path__ + "static/media/setting-white-icon.1e8fe300.svg";